import { BREED_KEYS } from "@./cat-calculations";
import { snakeCaseToCamelCase } from "@utils/misc";
import { useTranslations } from "next-intl";

import { createEnumTranslations } from "./createEnumTranslations";

export const useCatBreed = () => {
  const tBreeds = useTranslations("Cats.Breeds");
  const tVocabulary = useTranslations("Shared.Vocabulary");
  const unknown = tVocabulary("unknown");

  return createEnumTranslations({
    values: BREED_KEYS,
    translate: (breed) => {
      if (breed === "UNKNOWN") {
        return unknown;
      }

      return tBreeds(snakeCaseToCamelCase(breed));
    },
    fallback: unknown,
  });
};
